import Heading from 'components/Heading'
import Icon from 'components/Icon'
import Tooltip from 'components/Tooltip'
import * as React from 'react'
import { SRPRS_ENV } from '../../env'
import Content from '../../pages/shared/content'

interface MultiCityTooltipProps {
  children: JSX.Element
  icon: JSX.Element
  contentKey: string
  direction?: string
}

const MultiCityTooltip: React.FC<MultiCityTooltipProps> = props => {
  return (
    <Tooltip
      direction="down"
      useHover={SRPRS_ENV !== 'editable'}
      content={
        <div style={{ padding: '20px' }}>
          <div className="margin-b-s">
            <Icon icon={props.icon} />
          </div>
          <Heading level={3}>
            <Content contentKey={`${props.contentKey}-heading`}>A city</Content>
          </Heading>
          <span>
            <Content contentKey={props.contentKey}>{props.contentKey}</Content>
          </span>
        </div>
      }
    >
      {props.children}
    </Tooltip>
  )
}

export default MultiCityTooltip
